import { Box, Typography } from "@mui/material";
import dico from "src/shared/util/src/language/dico";
import icon from '../../assets/icon.png';

// Logo component
export default function Logo({ navigate, path = '/' }: { navigate: (path: string) => void, path?: string }) {
    return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexGrow: { xs: 1, md: 0 } }}>
        <img src={icon} alt="Meet Manager" style={{ width: '32px', height: '32px' }} />
        <Typography
            variant="h6"
            component="div"
            sx={{
                fontWeight: 'bold',
                cursor: 'pointer',

                marginRight: 4,
                color: 'text.primary',
                fontSize: '1.5rem',
                ml: 1,
            }}
            onClick={() => navigate(path)}
        >
            {dico().meetManager}
        </Typography>
    </Box>
    );
}